<div class="pdtImg {{ contextCssClass }}">
  <div class="pdtImg__main">
    <!-- DESKTOP || TABLET -->
    <div *ngIf="!isMobile; else mobileCarousel">
      <div class="slide">
        <ng-container *ngIf="lensEnabled">
          <img
            appMagnify
            [option]="lensOptions"
            width="100%"
            [alt]="picture.alt || defaultAlt"
            class="pdtImg__mainImg"
            [src]="imgixPath + '/produit/' + picture.path + '?w=auto&auto=format&fm=pjpg&ch=DPR'"
            (click)="openDialog($event)"
          />
        </ng-container>

        <ng-container *ngIf="!lensEnabled">
          <vc-images
            appCursor
            class="pdtImg__main__img"
            lazyOff="true"
            draggable="false"
            [url]="'/produit/' + picture.path"
            [width]="500"
            [alt]="picture.alt || defaultAlt"
            (click)="openDialog($event)"
          ></vc-images>
        </ng-container>
      </div>
    </div>
    <!-- // DESKTOP || TABLET -->

    <!-- MOBILE -->
    <ng-template #mobileCarousel>
      <vc-slider
        [pictures]="pictures"
        [indexSlide]="mainPictureIndex"
        [disableSwipe]="lensEnabled"
        (click)="openDialog($event)"
        (onSlide)="mainPictureIndex = $event"
      ></vc-slider>
    </ng-template>
    <!-- // MOBILE -->
  </div>

  <div class="pdtImg__nav" #scrollableZone (scroll)="onThumbScroll(scrollableZone)">
    <!-- DESKTOP & TABLET -->
    <ng-container *ngIf="isDesktop || isTablet">
      <button
        *ngIf="pictures?.length > 6"
        class="thumbControl thumbControl__prev leftRs"
        [disabled]="prevButtonDisabled"
        (click)="scrollToPrev(scrollableZone)"
      >
        <vc-sprite-icons name="arrow-head-up"></vc-sprite-icons>
      </button>

      <div *ngFor="let picture of pictures; index as index" (click)="display(index)" (mouseenter)="display(index)">
        <vc-images
          class="pdtImg__nav__thumb"
          [ngClass]="{'current-slide': mainPictureIndex === index}"
          lazyOff="true"
          draggable="false"
          [url]="'/produit/' + picture.path"
          [width]="60"
          [alt]="picture.alt || defaultAlt"
        ></vc-images>
      </div>

      <button
        *ngIf="pictures?.length > 6"
        class="thumbControl thumbControl__next rightRs"
        [disabled]="nextButtonDisabled"
        (click)="scrollToNext(scrollableZone)"
      >
        <vc-sprite-icons name="arrow-head-down"></vc-sprite-icons>
      </button>
    </ng-container>
    <!-- // DESKTOP & TABLET -->

    <!-- MOBILE -->
    <ng-container *ngIf="isMobile">
      <div class="pdtImg__nav__item" *ngFor="let picture of pictures; let i = index" (click)="display(i)">
        <span class="pdtImg__nav__bullet" [ngClass]="{active: mainPictureIndex == i}"></span>
        <vc-images
          class="pdtImg__nav__thumb"
          [ngClass]="{'current-slide': mainPictureIndex == i}"
          lazyOff="true"
          draggable="false"
          [url]="'/produit/' + picture.path"
          [width]="60"
          [alt]="picture.alt || defaultAlt"
        ></vc-images>
      </div>
    </ng-container>
    <!-- // MOBILE -->
  </div>
</div>

<vc-gallery-markup></vc-gallery-markup>
